export enum ReferralProgram {
    LEGACY = 'FOURTEEN_DAY_FREE_TRIAL_GIVE_100_GET_100',
    PREMIUM_TRIAL = 'PREMIUM_3_MO_TRIAL_GIVE_100_GET_100',
}

export interface ReferralDataTables {
    readyToBePaid: ReferralContext[];
    pending: ReferralContext[];
    processed: ReferralTrackingDisplayDto[];
    expired: ReferralContext[];
}

export interface ReferralSummaryResponseDto {
    [ReferralProgram.LEGACY]: ReferralDataTables;
    [ReferralProgram.PREMIUM_TRIAL]: ReferralDataTables;
}

export interface ReferralContext {
    program: ReferralProgram;
    referral_id: string;
    membership_id: string;
    referrer_id: string;
    referrer_name: string;
    referrer_membership_id: string;
    referrer_bank_account_id?: string | null;
    referrer_synctera_account_id?: string | null;
    referee_primary_user_id?: string | null;
    referee_primary_name?: string | null;
    referee_partner_user_id?: string | null;
    referee_partner_name?: string | null;
    referee_bank_account_id?: string | null;
    referee_synctera_account_id?: string | null;
    referral_created_at: string | Date;
    referee_days_since_signup?: number | null;
    referee_guidance_session_discovery_status: string;
    referee_guidance_session_money_map_status: string;
    referee_guidance_session_optimization_status?: string | null;
    referee_stripe_status: string | null;
    ready_to_pay: boolean;
    expired: boolean;
    referee_money_map_includes_open_cash: boolean;
    referee_first_cash_opened_at?: string | Date | null;
    referee_has_qualifying_direct_deposit: boolean;
    referee_qualifying_dd_cents?: number | null;
    referrer_has_open_cash: boolean;
    // Used for grove front-end handling only, not passed from backend
    decision_logged_in_grove?: boolean;
}

export interface ReferralTrackingDisplayDto {
    id: string;
    program: ReferralProgram;
    membership_id: string;
    referrer_id: string;
    referrer_name: string;
    referrer_bank_account_id?: string | null;
    referrer_synctera_reward_id?: string | null;
    referrer_reward_amount_cents?: number | null;
    referrer_reward_transaction_uuid?: string | null;
    referee_bank_account_id?: string | null;
    referee_synctera_reward_id?: string | null;
    referee_reward_amount_cents?: number | null;
    referee_reward_transaction_uuid?: string | null;
    referrer_payout_method?: ReferralPartyPayoutMethod | null;
    referee_payout_method?: ReferralPartyPayoutMethod | null;
    referrer_stripe_balance_transaction_id?: string | null;
    referee_stripe_balance_transaction_id?: string | null;
    note?: string | null;
    context: unknown; // Prisma.JsonValue
    created_at: string;
    updated_at?: string;
}

export enum ReferralPartyPayoutMethod {
    SYNCTERA_REWARD = 'SYNCTERA_REWARD',
    STRIPE_CREDIT = 'STRIPE_CREDIT',
    DO_NOT_PAY = 'DO_NOT_PAY',
}

export interface ReferralPartyPayoutDto {
    method: ReferralPartyPayoutMethod;
    bank_account_id?: string; // Required when `method` is `SYNCTERA_REWARD`.
}

export interface AdminBankOpsManualReferralRewardPayoutRequestDto {
    context: ReferralContext;
    referrer_payout: ReferralPartyPayoutDto;
    referee_payout: ReferralPartyPayoutDto;
    note?: string;
}

export interface AdminBankOpsManualReferralRewardPayoutResponseDto {
    id: string;
    referrerId: string;
    membershipId: string;
    program: ReferralProgram;
    referrerPayoutMethod: ReferralPartyPayoutMethod | null;
    refereePayoutMethod: ReferralPartyPayoutMethod | null;
    referrerBankAccountId: string | null;
    referrerSyncteraRewardId: string | null;
    referrerRewardAmountCents: number | null;
    referrerRewardTransactionUuid: string | null;
    referrerStripeBalanceTransactionId: string | null;
    refereeBankAccountId: string | null;
    refereeSyncteraRewardId: string | null;
    refereeRewardAmountCents: number | null;
    refereeRewardTransactionUuid: string | null;
    refereeStripeBalanceTransactionId: string | null;
    onExclusionList: boolean | null;
    note: string | null;
    context: unknown;
    createdAt: Date;
    updatedAt: Date;
}
